module.exports = __webpack_public_path__ + "static/vf_mpaddings_core.13fb95de.svg";